<template>
  <Loader v-if="loader" />
  <TabView v-model:activeIndex="active">
    <TabPanel header="Fatture scadute">
      <div class="col-12 flex justify-content-end align-items-center" style="font-size: 0.9em;">
        <label class="m-1">Tutti</label>
        <InputSwitch v-model="view_point" class="m-1" @update:modelValue="getData" />
        <label class="m-1">Solo Point</label>
      </div>
      <div class="card flex flex-column">
        <div class="col-12 flex justify-content-between align-items-center">
          <div class="col-12 flex justify-content-center align-items-center"> <Button icon="pi pi-angle-double-left"
              class="p-button-text p-button-rounded" @click="changeDate(false)" />
            <label class="m-1">Data</label>
            <Calendar v-model="date" dateFormat="dd/mm/yy" @update:modelValue="getData()" :manualInput="false"
              class="mx-2" style="width: 300px;" />
            <Button icon="pi pi-angle-double-right" class="p-button-text p-button-rounded" @click="changeDate()" />
          </div>
        </div>
        <div v-if="!has_invoices" class="flex justify-content-center align-items-center" style="height: 100%; margin-top: 10px;">
          <InlineMessage severity="warn" class="text-center">
            Non ci sono fatture scadute e non pagate del {{
              moment(date).subtract(5, "days").format("DD/MM/Y")
            }}
          </InlineMessage>
        </div>
        <Accordion>
          <AccordionTab v-for="tab in invoices" :key="tab.nome" :header="tab.nome">
            <DataTable :value="tab.fatture" class="w-full" :rowClass="rowClass" scrollable scrollDirection="horizontal">
              <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header" :type="col.type"
                :style="{ minWidth: col.minWidth }">
                <template #body="{ data }">
                  <div v-if="col.type == 'link'">
                    <Button :class="[
                      {
                        'p-button-link':
                          data.email_cliente != '' &&
                          data.email_cliente != null,
                      },
                      {
                        'p-button-color-white':
                          data.email_cliente == '' ||
                          data.email_cliente == null,
                      },
                    ]" :label="data[col.field]" @click="goTo($event, data, col.field)" />
                  </div>
                  <div v-else-if="col.type == 'price'" class="flex justify-content-end">
                    € {{ data[col.field] }}
                  </div>
                  <div v-else-if="col.type == 'data'" class="flex flex-column">
                    {{
                      data[col.field] != null
                        ? moment(data[col.field]).format("DD/MM/Y")
                        : data[col.field]
                    }}
                    <small v-if="
                      col.field == 'data_invio' && data.type_sollecito == 2
                    " class="p-error">
                      Sollecito da Storno Rid
                    </small>
                  </div>
                  <div v-else>
                    {{ data[col.field] }}
                  </div>
                </template>
              </Column>
              <Column>
                <template #body="{ data }">
                  <Button v-if="!data.data_invio && data.email_cliente" icon="pi pi-send" v-tooltip="`Invia sollecito`"
                    @click="sendSollecito(data)" />
                  <i v-if="!data.email_cliente" v-tooltip="`Email assente`" class="pi pi-times" />
                  <p v-if="data.data_invio">Sollecito inviato</p>
                </template>
              </Column>
            </DataTable>
          </AccordionTab>
        </Accordion>
      </div>
    </TabPanel>
  </TabView>
</template>

<script>
import Service from "@/services/ask-management/preavvisi-fatture-clienti-service";
import ServiceOperation from "@/services/ask-operation/operation-service.js";
import { ref, onMounted, getCurrentInstance, computed } from "vue";
import { FilterMatchMode } from "primevue/api";
import Loader from "@/components/Loader.vue";
import moment from "moment";
import { useToast } from "primevue/usetoast";
import { isEmpty } from "underscore";

export default {
  components: {
    Loader,
  },
  setup() {
    const loader = ref(false);
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const formatDate = self.appContext.config.globalProperties.$formatDate;
    const service = new Service(self.$http, self.$eventBus);
    const serviceOperation = new ServiceOperation(self.$http, self.$eventBus);
    const invoices = ref({});
    const has_invoices = ref(false);
    const view_point = ref(true);
    const date = ref();
    const typesClient = ref();
    const columns = [
      {
        field: "numero",
        header: "Numero Fattura",
        type: "link",
        minWidth: "150px",
      },
      {
        field: "code_fornitura",
        header: "Fornitura",
        type: "link",
        minWidth: "180px",
      },
      {
        field: "totale_fattura",
        header: "Importo Fattura €",
        type: "price",
        minWidth: "150px",
      },
      {
        field: "saldo",
        header: "Importo da Saldare €",
        type: "price",
        minWidth: "150px",
      },
      { field: "contabili", header: "Contabili", minWidth: "130px" },
      { field: "dilazioni", header: "Dilazioni", minWidth: "130px" },
      {
        field: "agente_firmatario",
        header: "Agente Firmatario",
        minWidth: "180px",
      },
      { field: "tipo_cliente", header: "Tipo cliente", minWidth: "150px" },
      { field: "cliente", header: "Cliente", type: "link", minWidth: "150px" },
      {
        field: "data_emissione",
        header: "Data emissione",
        type: "data",
        minWidth: "130px",
      },
      {
        field: "data_scadenza",
        header: "Data scadenza",
        type: "data",
        minWidth: "130px",
      },
      {
        field: "data_invio",
        header: "Data sollecito",
        type: "data",
        minWidth: "150px",
      },
      {
        field: "stato_fornitura",
        header: "Stato Fornitura",
        minWidth: "150px",
      },
    ];
    const active = ref(0);

    const pp_da_sospendere = ref([]);
    const selected_pp_da_sospendere = ref([]);
    const metaKey = ref(true);
    const columns_sospensioni = [
      { field: "numero", header: "Numero Fattura", type: "link" },
      { field: "nomeAgente", header: "Agente", type: "link" },
      { field: "nomeRappresentante", header: "Rappresentante", type: "link" },
      { field: "cliente", header: "Cliente", type: "link" },
      { field: "code", header: "Fornitura", type: "link" },
      { field: "data_fine", header: "Data fine", type: "data" },
      { field: "data_invio", header: "Data invio sollecito", type: "data" },
      { field: "email", header: "Email" },
    ];
    onMounted(() => {
      date.value = new Date();
      loader.value = true;
      Promise.all([getAllTipoClient()])
        .then(() => {
          getData();
        })
        .finally(() => {
          loader.value = false;
        });
    });

    const getData = () => {
      invoices.value = {};
      loader.value = true;
      let data_scadenza = moment(date.value)
        .subtract(5, "days")
        .format("Y-MM-DD");
      let fd = new FormData();
      fd.append("data", JSON.stringify(data_scadenza));
      fd.append("view_point", view_point.value);

      service
        .getFattureVenditaScadute(fd)
        .then((res) => {
          invoices.value = res.items;
          Object.keys(invoices.value).forEach((element) => {
            invoices.value[element].fatture.forEach((fattura) => {
              fattura.tipo_cliente = typesClient.value.find(
                (type) => type.id == fattura.cod_type_client
              ).name;
            });
          });

          has_invoices.value = !isEmpty(invoices.value);
        })
        .finally(() => {
          loader.value = false;
        });
    };
    const getAllTipoClient = async () => {
      await serviceOperation.getAllTipoClient().then((res) => {
        typesClient.value = res.items;
      });
    };

    const sendSollecito = (data) => {
      loader.value = true;
      let fd = new FormData();
      fd.append("id_fattura", data.id_fattura);
      service
        .sendSolleciti5g(fd)
        .then((res) => {
          let severity = res.items ? "success" : "danger";
          let summary = res.items ? "Successo" : "Attenzione";
          let detail = "Sollecito " + (res.items ? "" : "non ") + "inviato";

          if (severity != "warning") {
            toast.add({
              severity: severity,
              summary: summary,
              detail: detail,
              life: 10000,
            });
          }
          getData();
        })
        .finally(() => {
          loader.value = false;
        });
    };
    const changeDate = (value = true) => {
      if (value) {
        date.value = new Date(moment(date.value).add(1, "day"));
      } else {
        date.value = new Date(moment(date.value).subtract(1, "day"));
      }
      getData();
    };
    const rowClass = (data) => {
      return [
        { "bg-danger": data.email_cliente == null || data.email_cliente == "" },
      ];
    };

    const goTo = (evt, data, type_path) => {
      let path;
      let type_data;
      switch (type_path) {
        case "cliente":
          path = `clienti`;
          type_data = `id_${type_path}`;
          break;
        case "numero":
          path = `clienti/fatture`;
          type_data = type_path;
          break;
        case "nomeRappresentante":
          path = `rappresentanti`;
          type_data = "idRapp";
          break;
        case "nomeAgente":
          path = `agenti`;
          type_data = "id_agente";
          break;

        default:
          path = `${data.type_fornitura}s`;
          type_data = `id_${data.type_fornitura}`;
          break;
      }
      window.open(`/ask/${path}/${data[type_data]}/dettagli`, "_blank");
    };

    const isVisibleBtnDaSospendere = computed(() => {
      return selected_pp_da_sospendere.value.length;
    });

    const daSospendere = () => {
      let da_sospendere = selected_pp_da_sospendere.value.filter(
        (pp) => pp.stato != 3
      );
      if (da_sospendere.length) {
        loader.value = true;
        service
          .createMultiPreSuspensionOrReactivation(
            da_sospendere,
            "",
            "sospensioni"
          )
          .then((res) => {
            let severity = res.result.success ? "success" : "danger";
            let summary = res.result.success ? "Successo" : "Attenzione";
            let detail = res.result.msg;

            toast.add({
              severity: severity,
              summary: summary,
              detail: detail,
              life: 10000,
            });
          })
          .finally(() => {
            loader.value = false;
          });
      } else {
        selected_pp_da_sospendere.value = [];
        toast.add({
          severity: "warn",
          summary: "",
          detail:
            "Le sospensioni selezionate corrispondono a forniture cessate",
          life: 10000,
        });
      }
    };

    return {
      invoices,
      has_invoices,
      view_point,
      loader,
      service,
      getData,
      formatDate,
      filters,
      moment,
      date,
      columns,
      sendSollecito,
      changeDate,
      rowClass,
      goTo,
      active,
      pp_da_sospendere,
      selected_pp_da_sospendere,
      metaKey,
      isVisibleBtnDaSospendere,
      daSospendere,
      columns_sospensioni,
    };
  },
};
</script>

<style scoped>

.p-button-color-white {
  color: white !important;
  background: transparent !important;
  border: transparent !important;
}

.shadow-2 {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.border-round {
  border-radius: 8px;
}

.no-underline-tabview .p-tabview-nav::before {
  display: none;
}

.no-underline-tabview .p-tabview-nav-container::before {
  display: none;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.accordion-container {
  width: 120%;
  padding: 0;
}

.table-container {
  overflow-x: auto;
}

.accordion-content {
  padding: 1rem;
}

.shadow-2 {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.border-round {
  border-radius: 8px;
}

.p-datatable .p-datatable-thead>tr>th,
.p-datatable .p-datatable-tbody>tr>td {
  text-align: center;
  vertical-align: middle;
  padding: 0.75rem;
  white-space: nowrap;
}

.p-datatable-thead>tr>th {
  background-color: #aabdd8;
  font-weight: bold;
  border-bottom: 2px solid #dee2e6;
}

.p-datatable-tbody>tr>td {
  border-bottom: 1px solid #e9ecef;
}

.table-container {
  overflow-x: auto;
  width: 100%;
}
</style>
